"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = exports.Small = exports.Text = exports.Subheading = exports.Tertiary = exports.Secondary = exports.Primary = exports.Title = void 0;
var Typography_1 = require("./Typography");
exports.Title = (0, Typography_1.makeTitle)('h1');
exports.Primary = (0, Typography_1.makePrimary)('h1');
exports.Secondary = (0, Typography_1.makeSecondary)('h2');
exports.Tertiary = (0, Typography_1.makeTertiary)('h3');
exports.Subheading = (0, Typography_1.makeSubheading)('span');
exports.Text = (0, Typography_1.makeText)('span');
exports.Small = (0, Typography_1.makeSmall)('small');
exports.Paragraph = (0, Typography_1.makeText)('p');
exports.default = { Title: exports.Title, Primary: exports.Primary, Secondary: exports.Secondary, Tertiary: exports.Tertiary, Subheading: exports.Subheading, Text: exports.Text, Small: exports.Small, Paragraph: exports.Paragraph };
